import { useState } from 'react';

interface UsePaginationParams {
  initialPage?: number;
  pageSize?: number;
}

interface UsePaginationReturn {
  data: {
    page: number;
    pageSize: number;
    totalPages: number;
  };
  actions: {
    setPage: (page: number) => void;
    setTotalPages: (total: number) => void;
    resetToFirstPage: () => void;
    handlePageChange: (_event: React.ChangeEvent<unknown>, value: number) => void;
  };
}

export function usePagination({ 
  initialPage = 0, 
  pageSize = 10 
}: UsePaginationParams = {}): UsePaginationReturn {
  const [page, setPage] = useState(initialPage);
  const [totalPages, setTotalPages] = useState(0);

  const resetToFirstPage = () => setPage(0);

  const handlePageChange = (_event: React.ChangeEvent<unknown>, value: number) => {
    setPage(value - 1); // MUI Pagination is 1-based, our API is 0-based
  };

  return {
    data: {
      page,
      pageSize,
      totalPages,
    },
    actions: {
      setPage,
      setTotalPages,
      resetToFirstPage,
      handlePageChange,
    },
  };
}
